import { useMemo, useEffect } from "react";

import { Checkbox } from "@newsela/angelou";
import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";

import generateAdminContentSettingsFormData from "@/admin/utils/generateAdminContentSettingsFormData/generateAdminContentSettingsFormData";
import generateContentSettingsGroupName from "@/admin/utils/generateContentSettingsGroupName";
import {
  contentSettingsCheckboxCss,
  contentSettingsContainerCss,
  contentSettingsTextCss,
} from "./AdminContentSettingsCardFooter.styles";

const AdminContentSettingsCardFooter = ({
  contentId,
  contentSettingsGroups,
  visibilityMarkers,
  style = {},
}) => {
  const { control, resetField } = useFormContext();

  const formDefaultValues = useMemo(
    () =>
      generateAdminContentSettingsFormData({
        contentId,
        contentSettingsGroups,
        visibilityMarkers,
      }),
    [contentId, contentSettingsGroups, visibilityMarkers],
  );

  useEffect(() => {
    formDefaultValues[contentId].forEach((defaultValue, index) => {
      resetField(`${contentId}[${index}]`, {
        defaultValue,
        keepDirty: true,
      });
    });
  }, [contentId, formDefaultValues]);

  return (
    <div css={contentSettingsContainerCss} style={style}>
      <div css={contentSettingsTextCss}>Flag for grade levels</div>
      {contentSettingsGroups.map((group, index) => {
        const groupLabel = generateContentSettingsGroupName(group);
        const groupName = `${contentId}[${index}].group_id`;
        const groupKey = `${contentId}[${index}].is_flagged`;
        const defaultValue = formDefaultValues[contentId][index].is_flagged;

        return (
          <div css={contentSettingsCheckboxCss} key={groupName}>
            <Controller
              name={groupKey}
              control={control}
              defaultValue={defaultValue}
              render={({ field }) => (
                <Checkbox
                  label={groupLabel}
                  {...field}
                  checked={field.value}
                  onChange={(e) => {
                    field.onChange(e.target.checked);
                  }}
                />
              )}
            />
          </div>
        );
      })}
    </div>
  );
};

AdminContentSettingsCardFooter.propTypes = {
  contentId: PropTypes.string.isRequired,
  contentSettingsGroups: PropTypes.array.isRequired,
  visibilityMarkers: PropTypes.array,
  style: PropTypes.object,
};

export default AdminContentSettingsCardFooter;
